import {
  onlinePortalMustPrintApplication,
  printMailDisabled,
} from '~components/Absentee/navigateToSecondStep';
import { registrationPrintMailDisabled } from '~components/Register/specialCases';

export const nvraUrl =
  'https://turnout-public-files.s3.us-west-2.amazonaws.com/register/states/Federal_Voter_Registration_ENG.pdf';
export const electionsByMailOnly = ['OR'];

export const idSummaries = {
  government_photo_id:
    'You must show a government-issued photo ID when you vote.',
  photo_id: 'You must show a photo ID when you vote.',
  id: 'You must show ID when you vote.',
  hava_only: 'First-time voters must show ID when they vote.',
};

export const formatLocalElectionOfficeLink = (stateCode) => {
  return `[local election office](/local-election-offices/${stateCode})`;
};

export const stripReceivedPostmarkedFromDeadline = (deadline) => {
  return deadline
    .replace('received', '')
    .replace('postmarked', '')
    .replace('by', '')
    .replace('(', '')
    .replace(')', '')
    .trim();
};

export const getMailDeadlineType = (deadline) => {
  return deadline.includes('postmarked') ? 'postmarked' : 'received';
};

export const formatMailDeadline = (deadline) => {
  if (deadline === 'N/A') {
    return deadline;
  }
  if (deadline.includes('(postmarked)') || deadline.includes('(received)')) {
    return `${getMailDeadlineType(deadline)} by ${stripReceivedPostmarkedFromDeadline(deadline)}`;
  }
  return `received by ${deadline}`;
};

// Accounts for the possibility of a state polling place locator being NULL
export const getPollingPlaceLocatorLink = (stateInfo) => {
  return stateInfo.gov_tool_polling_place.text
    ? stateInfo.gov_tool_polling_place.text
    : '/where-to-vote/';
};

export const hasEarlyVoting = (stateInfo) => {
  return (
    stateInfo.early_voting_starts.text &&
    stateInfo.early_voting_starts.text !== 'N/A'
  );
};

export const getRegistrationForm = (stateInfo, stateCode) => {
  if (registrationPrintMailDisabled.includes(stateCode)) {
    return stateInfo.source_registration_info.text;
  }

  return stateInfo.pdf_register_form.text || nvraUrl;
};

export const getAbsenteeMailLink = (stateInfo, stateCode) => {
  if (onlinePortalMustPrintApplication.includes(stateCode)) {
    return stateInfo.gov_tool_absentee_request.text;
  }

  if (printMailDisabled.includes(stateCode)) {
    return stateInfo.source_absentee_info.text;
  }

  return stateInfo.pdf_absentee_form.text;
};

export const getNoRegistrationStatement = (stateName) => {
  return `${stateName} does not have voter registration. Just bring your ID to the polls and vote.`;
};

export const isOnlineAbsenteeRequestAvailable = (stateInfo, stateCode) => {
  return (
    stateInfo.absentee_request_methods.multiselect_value.includes('online') &&
    !onlinePortalMustPrintApplication.includes(stateCode)
  );
};
